/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import demo from './../assets/banner.jpg';

const MovieDetails = ({ currentMovieDetail, posterImage, setShowModal }) => {
    return (
        <div className="flex flex-col gap-3 lg:flex-row md:flex-row bg-slate-900 p-3 rounded-lg mb-20 w-full">
            <div className='w-[100%] lg:w-[20%] md:w-[20%]'>

                <img src={
                    (currentMovieDetail?.poster_path)
                        ?
                        posterImage
                        :
                        demo

                } alt="posterimage" className='w-full' />


            </div>

            <div className='w-[100%] lg:w-[80%] md:w-[80%]'>
                <div className='relative'>
                    <h1 className='text-[1.8rem]'>{currentMovieDetail?.original_title} <span className='text-[#8e9aa5] text-[50%]'>{
                        ((currentMovieDetail?.release_date?.length > 5) || (currentMovieDetail?.first_air_date?.length > 5))
                            ?
                            currentMovieDetail?.release_date?.slice(0, 4) || currentMovieDetail?.first_air_date?.slice(0, 4)
                            :
                            currentMovieDetail?.release_date || currentMovieDetail?.first_air_date

                    }</span></h1>
                    <div className='border-2 border-[#9eac03] absolute top-10 lg:top-0 md:top-10 right-0 p-1 lg:p-3 md:p-2 rounded w-[35%] lg:w-[25%] md:w-[30%] text-center'>
                        <a href="#" onClick={() => setShowModal(true)}>Subscribe to Watch | $0.00</a>
                    </div>
                </div>
                <div className='my-3'>
                    <div className='flex gap-1'>
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaStar className='text-warning' />
                        <FaRegStar />
                        <FaRegStar />
                    </div>
                    <div>
                        <span className='text-[80%]'>{currentMovieDetail?.vote_average}/10</span> <span className='text-[80%]'>by {currentMovieDetail?.vote_count} users</span>
                    </div>
                </div>
                <div className='mb-3'>
                    <p className='text-slate-400'>{currentMovieDetail?.overview}</p>
                </div>
                <div>
                    <ul>
                        <li className='p-2 rounded bg-slate-800'><span className='text-slate-400'>Released</span>: <span>{currentMovieDetail?.release_date || currentMovieDetail?.first_air_date}</span></li>

                        <li className='p-2 rounded'><span className='text-slate-400'>Runtime:</span> <span>{currentMovieDetail?.runtime} minutes</span></li>

                        <li className='p-2 rounded bg-slate-800'><span className='text-slate-400'>Genre:</span> {currentMovieDetail?.genres?.map(genre => genre.name).join(', ')}</li>

                        <li className='p-2 rounded'><span className='text-slate-400'>Popularity:</span> <span>{currentMovieDetail?.popularity} Likes</span></li>

                        <li className='p-2 rounded bg-slate-800'><span className='text-slate-400'>production Companies:</span> {currentMovieDetail?.production_companies?.map(production => production.name).join(', ')}</li>

                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MovieDetails;